// AUTHENTICATION
export * from './AuthService';

// CRUD OPERATIONS
export * from './GetListService.js';
export * from './GetOneService.js';
export * from './GetManyService.js';
export * from './GetManyReferenceService.js';
export * from './UpdateService.js';
export * from './CreateService.js';
export * from './DeleteService.js';



// WEBPACK FOOTER //
// ./src/services/index.js